export default {
  testimonial: {
    subtitle: "آراء العملاء",

    title1: "موثوق من قبل",
    title2: "المطاعم والشركات",

    review:
      "لقد غير MAHAL طريقة حصولنا على الإمدادات الغذائية. الأسعار الشفافة والتوصيل الموثوق يجعل العمليات أكثر سلاسة.",

    role: "عميل تجاري",
  },
};